/* global angular  moment swal */
import './style.less';
import { deliveryMethods } from '@prolaera/library';
import { keyBy, orderBy } from 'lodash';

export default function(
  $state,
  $log,
  $stateParams,
  $sce,
  $timeout,
  $q,
  $filter,
  Swal,
  ApiClass,
  ProfileClass,
  RegulatorClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const reg_id = $stateParams.reg_id;

  // Disables features
  const { profile } = ProfileClass.profileComplete;
  vm.disable = profile && profile.company_id === 10 && !profile.admin;
  vm.emailAddress = {
    8: 'achan@ssfllp.com',
    10: 'mvance@cbmcpa.com'
  }[profile.company_id];

  const hours = {
    category: '',
    credits: ''
  };

  vm.addHours = () => {
    const template = angular.copy(hours);
    vm.formData.hours.push(template);
  };

  vm.removeHours = index => vm.formData.hours.splice(index, 1);

  vm.who = "you don't ";
  vm.filterVisable = false;

  vm.delete = cert => {
    const certId = cert.cert_id;
    Swal.delete()
      .then(() => {
        cert.deleteBtn = true;
        return ApiClass.usersIdTypeTypeIdDelete(
          {
            id: profile_uid,
            type: 'certificates',
            type_id: certId,
            manage: false
          },
          undefined,
          { queryParams: { 'process.update_compliance': true } }
        );
      })
      .then(() => activate())
      .catch(error => {
        cert.deleteBtn = false;
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.submit = cert => {
    vm.submitBtn = true;

    const { cyc_yr, hours, regulator } = cert;

    const cycle_date = vm.flatComplianceDict[cyc_yr].cycle_date;

    const params = {
      cyc_yr,
      cycle_date,
      date: moment(cycle_date)
        .subtract(1, 'days')
        .toISOString(),
      delivery: 'Carry Over',
      delivery_uid: 7,
      hours_basic: {},
      profile_uid: $stateParams.id,
      reg_id: regulator
    };

    params.hours_basic[regulator] = hours;

    ApiClass.usersIdTypePut({ id: profile_uid, type: 'carryover', manage: false }, params, {
      queryParams: { 'process.update_compliance': true }
    })
      .then(() => {
        vm.submitBtn = false;
        activate();
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Users Carry Over Activated');

    vm.itemsPerPage = 20;

    vm.formData = {
      profile_uid,
      hours: [
        {
          category: '',
          credits: ''
        }
      ],
      carry_over: true,
      regulator: reg_id
    };

    const qArr = [
      RegulatorClass.loadRegulators(),
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:flatcompliance': true,
            'include:carryover': true
          }
        }
      )
    ];

    return $q
      .all(qArr)
      .then(([{ objCurrent: regulatorDict }, { data: { flatcompliance, carryover } }]) => {
        vm.deliveryMethods = deliveryMethods;
        vm.regulators_dict = regulatorDict;
        vm.complianceDict = {};
        vm.flatComplianceDict = keyBy(flatcompliance, 'cyc_yr');

        const filteredCarryOverHours = carryover.filter(cert => {
          return cert.reg_id === reg_id;
        });

        vm.rawCerts = orderBy(filteredCarryOverHours, ['cyc_yr'], ['desc']);

        flatcompliance
          .filter(license => {
            return (
              license.reg_id == reg_id &&
              regulatorDict[license.reg_id] &&
              regulatorDict[license.reg_id].cycle_limiter &&
              regulatorDict[license.reg_id].cycle_limiter.carry
            );
          })
          .forEach(license => {
            vm.complianceDict[license.reg_id] = vm.complianceDict[license.reg_id] || [];
            vm.complianceDict[license.reg_id].push(license);
          });

        vm.complianceKeys = Object.keys(vm.complianceDict);
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/license/carryOver/index.js